import { Env } from './type';

export const environment: Env = {
  msal: {
    clientId: 'a50255d5-b70c-453c-ade6-1e7eebfb2d31',
    authority: 'https://login.microsoftonline.com/a5e6c6bd-17f0-4980-be25-49bcd5c558ae',
    scopes: ['api://echeck_dev/roles'],
  },
  apiUrl: 'https://api.echeckdeveb.ids.telekom.net',
};
